import React, { useEffect, useState } from 'react';
import FromDateToDateStat from './stats/FromDateToDateStat';
import UserInputStat from './stats/UserInputStat';
import ReconcileEntry from './stats/reconcile/ReconcileEntry';
import LoadingModal from './LoadingModal';
import CookieManager from '../CookieManager';
import { useNavigate } from 'react-router-dom';

const Home = () => {
  const [reports, setReports] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const loadReports = async () => {
      try {
        const response = await fetch('/stats/reports', {
          headers: CookieManager.authHeader(),
        });

        if (!response.ok) {
          if (response.status === 401) {
            CookieManager.remove();
            navigate("/login");
          }
          return;
        }

        const data = await response.json();
        setReports(
          [...data].sort((a, b) => a.sortOrder - b.sortOrder)
        );
      }
      catch (error) {
        console.error(error);
      }
    };

    loadReports();
  }, [navigate]);

  const handleSubmit = async (e, endpoint, payload, format = null) => {
    e.preventDefault();
    try {
      setIsLoading(true);

      const endpointUrl = format ? `${endpoint}?format=${format}` : endpoint;

      const response = await fetch(endpointUrl, {
        method: 'POST',
        headers: CookieManager.authHeader(),
        body: JSON.stringify(payload),
      });

      if (response.status === 401) {
        CookieManager.remove();
        navigate("/login");
        return;
      }

      if (format === "json") {
        const data = await response.json();

        navigate("/results", {
          state: { results: data },
        });
      }
      else {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");

        link.href = url;
        link.setAttribute(
          "download",
          response.headers
            .get("Content-Disposition")
            ?.split(";")[1]
            .replace(" filename=", ""),
        );

        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const renderReport = (report) => {
    switch (report.component) {

      case "FromDateToDateStat":
        return (
          <FromDateToDateStat
            key={report.code}
            code={report.code}
            caption={report.caption}
            maxDays={report.maxDays}
            endpoint={report.endpoint}
            handleSubmit={handleSubmit}
          />
        );

      case "UserInputStat":
        return (
          <UserInputStat
            key={report.code}
            code={report.code}
            caption={report.caption}
            label={report.inputParameter}
            placeHolder={report.placeHolder}
            allowEmptyInput={report.allowEmptyInput}
            showViewButton={report.showViewButton}
            endpoint={report.endpoint}
            handleSubmit={handleSubmit}
          />
        );

      case "ReconcileEntry":
        return (
          <ReconcileEntry
            key={report.code}
            code={report.code}
            caption={report.caption}
          />
        );

      default:
        return null;
    }
  };

  return (
    <div>
      {isLoading && <LoadingModal />}
      {reports.map(renderReport)}
    </div>
  );
};

export default Home;